export function commaizeInt(num) {
  return (num || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function commaize(num, currency) {
  if (currency === 'JPY') return commaizeInt(num);
  return (num || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function convert(price, rate, currency) {
  const converted = price * rate;
  return currency === 'JPY' ? Math.ceil(converted) : parseFloat(converted.toFixed(2));
}

export function ceil(price, cur, curs, isConvert = true) {
  if (cur === 'THB') {
    const frac = (price % 100) >= 90.001 && (price % 100) <= 99 ? 99 : (price % 100);
    return Math.ceil((Math.floor(price / 100) * 100) + frac);
  }
  if (cur in curs && isConvert) {
    if (['JPY', 'RUB'].indexOf(cur) >= 0) {
      return Math.ceil(price * curs[cur] / 10) * 10; //eslint-disable-line
    }
    return Math.ceil(price * curs[cur]);
  }
  if (['JPY', 'RUB'].indexOf(cur) >= 0) {
    return Math.ceil(price / 10) * 10;
  }
  return Math.ceil(price);
}



// WEBPACK FOOTER //
// ./src/utils/pricing.js